import { render, staticRenderFns } from "./serviceProviderDetails.vue?vue&type=template&id=18e52a83&"
import script from "./serviceProviderDetails.vue?vue&type=script&lang=ts&"
export * from "./serviceProviderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./serviceProviderDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports